import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Inform from '../../assets/icons/Inform.svg';
import Message from '../../assets/icons/Message.svg';
import Alert from '../../assets/icons/Alert.svg';
import Support from '../../assets/icons/Support.svg';
import Logout from '../../assets/icons/Logout.svg';
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { getUserProfile, UserProfile } from "../../API/UserProfileApi/GetUserProfile";
import { toast } from "react-toastify";
import { useLocalization } from "../Context/MultiLanguageContext";
import Profile from '../../assets/icons/Profile.svg';
import { getApiBaseUrl, PREPROD_API_BASE_URL } from "../../utils/apiBaseUrl";
import packageJson from '../../../package.json';
const More: React.FC<{ updateUserName: (newUserName: string) => void }> = ({ updateUserName }) => {
  const navigate = useNavigate();
  const { t } = useLocalization();
  const isPreProd = getApiBaseUrl() === PREPROD_API_BASE_URL;

  const [userName, setUserName] = useState('');
  const [userProfile, setUserProfile] = useState<UserProfile | null>(null);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);

  useEffect(() => {
    const storedUserName = localStorage.getItem('userName');
    if (storedUserName) {
      setUserName(storedUserName);
    }
  }, []);

  const fetchAndHandleUserProfile = async () => {
    try {
      const data = await getUserProfile(t);
      setUserProfile(data);
      setUserName(data.userName);
      updateUserName(data.userName);
      navigate('/profile', {
        state: {
          userName: data.userName,
          email: data.email,
          phoneNumber: data.phoneNumber,
        },
      });
    } catch (error) {
      toast.error(t("sessionExpired"));
      navigate('/home');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('userToken');
    localStorage.removeItem('authToken');
    localStorage.removeItem('token');
    localStorage.removeItem('userName');

    sessionStorage.clear();
    navigate("/", { replace: true });
  };

  return (
    <div className="min-h-screen bg-magnolia flex flex-col">
      <Header
        userName={userName}
        fetchUserProfile={fetchAndHandleUserProfile}
        handleLogout={handleLogout}
      />

      <main className="flex-1 container mx-auto px-4 py-8">
        <div className="flex flex-col items-center justify-center">
          <div className="w-full max-w-md space-y-6">
            <button
              className="flex items-center p-4 rounded-lg shadow-md w-full bg-purple-200 hover:bg-purple-300 transition"
              onClick={() => fetchAndHandleUserProfile()}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white text-purple-500 text-2xl">
                <img src={Profile} className="w-6 h-6" />
              </div>
              <div className="ml-4 text-left">
                <h3 className="text-lg font-semibold text-gray-800">{t("profile")}</h3>
                <p className="text-sm text-gray-500">{t("viewandmanage")}</p>
              </div>
            </button>
            <button
              className="flex items-center p-4 rounded-lg shadow-md w-full bg-blue-100 hover:bg-blue-200 transition"
              onClick={() => navigate('/about')}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white text-blue-500 text-2xl">
                <img src={Inform} className="w-8 h-8" />
              </div>
              <div className="ml-4 text-left">
                <h3 className="text-lg font-semibold text-gray-800">{t("about")}</h3>
                <p className="text-sm text-gray-500">{t("learnMoreAboutApp")}</p>
              </div>
            </button>
            <button
              className="flex items-center p-4 rounded-lg shadow-md w-full bg-green-100 hover:bg-green-200 transition"
              onClick={() => navigate('/feedback')}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white text-green-500 text-2xl">
                <img src={Message} className="w-8 h-8" />
              </div>
              <div className="ml-4 text-left">
                <h3 className="text-lg font-semibold text-gray-800">{t("feedback")}</h3>
                <p className="text-sm text-gray-500">{t("shareYourFeedback")}</p>
              </div>
            </button>
            <button
              className="flex items-center p-4 rounded-lg shadow-md w-full bg-orange-100 hover:bg-orange-200 transition"
              onClick={() => navigate('/report-issue')}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white text-orange-500 text-2xl">
                <img src={Alert} className="w-8 h-8" />

              </div>
              <div className="ml-4 text-left">
                <h3 className="text-lg font-semibold text-gray-800">{t("reportIssue")}</h3>
                <p className="text-sm text-gray-500">{t("encounterProblems")}</p>
              </div>
            </button>
            <button
              className="flex items-center p-4 rounded-lg shadow-md w-full bg-pink-100 hover:bg-pink-200 transition"
              onClick={() => window.location.href = "https://getmethere.in/support.html"}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white text-pink-500 text-2xl">
                <img src={Support} className="w-8 h-8" />
              </div>
              <div className="ml-4 text-left">
                <h3 className="text-lg font-semibold text-gray-800">{t("support")}</h3>
                <p className="text-sm text-gray-500">{t("reliableSupport")}</p>
              </div>
            </button>
            <button
              className="mt-10 flex items-center text-blue-600 font-semibold hover:underline border border-gray-300 rounded-lg p-2 w-full justify-center"
              onClick={handleLogout}
            >
              <img src={Logout} className="w-6 h-6" /> {t("logout")}
            </button>
            
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default More;
